import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ViewKanban, ViewList } from '@mui/icons-material';

export type OrdersView = 'list' | 'board';

/** La vista elegida se recuerda por dispositivo: la pantalla de cocina vive en tablero */
export const ORDERS_VIEW_STORAGE_KEY = 'krispis.ordersView';

export const getStoredOrdersView = (): OrdersView => {
    try {
        return localStorage.getItem(ORDERS_VIEW_STORAGE_KEY) === 'board' ? 'board' : 'list';
    } catch (error) {
        return 'list';
    }
};

export const storeOrdersView = (view: OrdersView) => {
    try {
        localStorage.setItem(ORDERS_VIEW_STORAGE_KEY, view);
    } catch (error) {
        // Modo privado o storage lleno: la vista simplemente no se recuerda
    }
};

interface OrdersViewSwitchProps {
    view: OrdersView;
    onChange: (view: OrdersView) => void;
    fullWidth?: boolean;
    /** Modo compacto del tablero: solo iconos, para que la fila quepa en una tablet */
    compact?: boolean;
}

const OrdersViewSwitch: React.FunctionComponent<OrdersViewSwitchProps> = ({ view, onChange, fullWidth, compact }) => (
    <ToggleButtonGroup
        exclusive
        size="small"
        fullWidth={fullWidth}
        value={view}
        onChange={(_, value: OrdersView | null) => value && onChange(value)}
        sx={{
            flexShrink: 0,
            '& .MuiToggleButton-root': { px: compact ? 1 : 2, py: compact ? 0.75 : 1.15, textTransform: 'none' }
        }}
    >
        <ToggleButton value="list" aria-label="Vista de lista">
            <ViewList sx={{ fontSize: 20, mr: compact ? 0 : 0.75 }} />
            {!compact && 'Lista'}
        </ToggleButton>
        <ToggleButton value="board" aria-label="Vista de tablero">
            <ViewKanban sx={{ fontSize: 20, mr: compact ? 0 : 0.75 }} />
            {!compact && 'Tablero'}
        </ToggleButton>
    </ToggleButtonGroup>
);

export default OrdersViewSwitch;
